import resume__english from "../assets/Curriculum/Resume__English_Update.pdf";
import resume__spanish from "../assets/Curriculum/Resume__English_Update.pdf";

export const curriculum = {
  spanish: resume__spanish,
  english: resume__english,
};
